import React, { useState, useEffect } from 'react';
import './CambioMesaModal.css';
import MapaMesas from '../MapaMesas';
import API from '../../../../utils/api';

/**
 * Componente Modal para cambiar de mesa
 * @param {Object} props - Propiedades del componente
 * @param {boolean} props.visible - Indica si el modal es visible
 * @param {Function} props.onClose - Función para cerrar el modal
 * @param {Object} props.mesaActual - Datos de la mesa actual
 * @param {Object} props.pedidoActual - Datos del pedido actual
 * @param {Function} props.onCambioMesa - Función que se ejecuta al completar el cambio de mesa
 */
const CambioMesaModal = ({ visible, onClose, mesaActual, pedidoActual, onCambioMesa }) => {
  const [mesas, setMesas] = useState([]);
  const [mesaSeleccionada, setMesaSeleccionada] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Cargar mesas disponibles
  useEffect(() => {
    if (visible) {
      cargarMesas();
    }
  }, [visible]);

  const cargarMesas = async () => {
    try {
      setLoading(true);
      setError(null);

      // Obtener todas las mesas
      const mesasData = await API.mesas.getAll();

      // Filtrar solo mesas disponibles (no ocupadas) y excluir la mesa actual
      const mesasDisponibles = mesasData.filter(
        (mesa) =>
          (mesa.status === 'abierta' || mesa.status === undefined || mesa.status === '') &&
          mesa.idMesa !== mesaActual?.idMesa
      );

      setMesas(mesasDisponibles);
      setLoading(false);
    } catch (err) {
      console.error("Error al cargar mesas:", err);
      setError("No se pudieron cargar las mesas disponibles");
      setLoading(false);
    }
  };

  const handleMesaClick = (mesa) => {
    setMesaSeleccionada(mesa);
  };

  const confirmarCambioMesa = async () => {
    if (!mesaSeleccionada) {
      alert("Por favor, seleccione una mesa de destino");
      return;
    }

    try {
      setLoading(true);

      // Llamar al API para cambiar de mesa
      const resultado = await API.pedidos.cambiarMesa({
        idPedido: pedidoActual?.idPedido,
        idMesaOriginal: mesaActual?.idMesa,
        idMesaDestino: mesaSeleccionada.idMesa,
        numeroMesaDestino: mesaSeleccionada.numeroMesa || mesaSeleccionada.numero,
        nombreMesaDestino: mesaSeleccionada.nombreMesa || mesaSeleccionada.nombre || `Mesa ${mesaSeleccionada.numeroMesa || mesaSeleccionada.numero}`
      });

      setLoading(false);

      if (resultado.success) {
        // Ejecutar callback de cambio exitoso
        onCambioMesa(mesaSeleccionada);
        onClose();
      } else {
        alert(`Error al cambiar de mesa: ${resultado.message || 'Error desconocido'}`);
      }
    } catch (err) {
      console.error("Error al cambiar de mesa:", err);
      setLoading(false);
      alert("Error al cambiar de mesa. Por favor, intente de nuevo.");
    }
  };

  if (!visible) return null;

  return (
    <div className="modal-overlay">
      <div className="cambio-mesa-modal">
        <div className="modal-header">
          <h2>Cambiar de Mesa</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        <div className="info-mesas-compact">
          <div className="mesa-info">
            <div className="mesa-origen">
              <span className="info-label">Actual:</span>

              <span className="info-value">{mesaActual?.caption || `Mesa ${mesaActual?.numeroMesa}`}</span>
            </div>
            <div className="mesa-separator">→</div>
            <div className="mesa-destino">
              <span className="info-label">Destino:</span>
              <span className="info-value">
                {mesaSeleccionada ? (mesaSeleccionada.nombreMesa || mesaSeleccionada.nombre || `Mesa ${mesaSeleccionada.numeroMesa || mesaSeleccionada.numero}`) : "No seleccionada"}
              </span>
            </div>
          </div>
        </div>

        <div className="modal-body">
          <div className="mapa-mesas-container">
            {loading ? (
              <div className="loading-mesas">
                <div className="spinner"></div>
                <p>Cargando mesas disponibles...</p>
              </div>
            ) : error ? (
              <div className="error-message">{error}</div>
            ) : mesas.length === 0 ? (
              <div className="no-mesas-message">
                No hay mesas disponibles para cambio
              </div>
            ) : (
              <div className="mapa-wrapper">
                <div className="leyenda-mesas">
                  <div className="leyenda-item">
                    <div className="leyenda-color disponible"></div>
                    <span>Disponible</span>
                  </div>
                </div>
                <MapaMesas
                  mesas={mesas}
                  onMesaClick={handleMesaClick}
                />
              </div>
            )}
          </div>
        </div>

        <div className="modal-footer">
          <button
            className="cambiar-button"
            onClick={confirmarCambioMesa}
            disabled={!mesaSeleccionada || loading}
          >
            {loading ? "Procesando..." : "Confirmar Cambio"}
          </button>
          <button className="cancelar-button" onClick={onClose}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default CambioMesaModal;